module.exports = __webpack_public_path__ + "4bfd0831f0e2af5e546500fcae7d4346.MP3";